import { FC } from 'react'
import { useIntl } from 'react-intl'

import { PatientsAPI } from '@api/patientsAPI'

import { initialQueryState } from '@models/apiBase'
import { Option } from '@models/option'
import { PatientOptionModel } from '@models/patient'

import { AsyncPaginateSelectField, AsyncPaginateSelectFieldProps } from '@components/Form/AsyncPaginateSelect'

import { ReactSelectPatientOption } from '@modules/patients/components/ReactSelectPatientOption'

import TypeUtil from '@/utils/typeUtil'

type Props = Omit<AsyncPaginateSelectFieldProps<false>, 'onSearch' | 'interceptOnChange' | 'isMulti'>

const QueuePatientSelectField: FC<Props> = (props) => {
  const intl = useIntl()

  const searchDebounce = async (keyword: string) => {
    const response = await PatientsAPI.getOptionsForQueueNumberGenerateForm({
      ...initialQueryState,
      phrase: !TypeUtil.isEmpty(keyword) ? keyword : undefined,
    })

    if (response.data) {
      return {
        ...response.data,
        nodes: response.data.nodes.map((patient) => {
          return new Option<PatientOptionModel>({
            label: `#${patient.patient_id} - ${patient.full_name}`,
            value: patient.id,
            data: patient,
          })
        }),
      }
    }
  }

  return (
    <AsyncPaginateSelectField
      {...props}
      onSearch={searchDebounce}
      placeholder={intl.formatMessage({ id: 'patient.search.placeholder' })}
      components={{
        Option: ReactSelectPatientOption,
      }}
      noOptionsMessage={() => {
        return intl.formatMessage({
          id: 'appointment.patient.select_not_found',
        })
      }}
    />
  )
}

export default QueuePatientSelectField
